import type { UIEvent } from 'react';
import { Icon, Image } from 'ui/components/primitives';

import type { DataTracking } from 'core/middlewares/trackingGA4';

import { FooterComponents } from '../Footer.styles';
import type { SocialProps } from './components.d';
import { SocialComponents } from './components.styles';

const googlePlay = '/images/store-google.png';
const appleStore = '/images/store-apple.png';
import { app } from 'core';

export const Social = ({ data }: SocialProps) => {
  const { trackClick } = app.commands.useAppCommand();

  const handleTrackClick = (event: UIEvent<HTMLAnchorElement>) => {
    const {
      currentTarget: { dataset },
    } = event;
    const trackData = {
      eventAction: 'clique:rodape',
      eventCategory: 'geral',
      eventLabel: dataset.label,
    } as DataTracking;

    trackClick(event, 'event', trackData);
  };

  return (
    <SocialComponents.Component>
      <SocialComponents.Section>
        <FooterComponents.Title>{data?.appCTA}</FooterComponents.Title>

        <SocialComponents.List>
          <SocialComponents.ItemList>
            <SocialComponents.ImageWrapper>
              <SocialComponents.SocialLinks
                data-label="botao-play-store"
                onClick={handleTrackClick}
                to={data?.android}
              >
                <Image src={googlePlay} alt="Acessar aplicativo na Google Play" />
              </SocialComponents.SocialLinks>
            </SocialComponents.ImageWrapper>
          </SocialComponents.ItemList>
          <SocialComponents.ItemList>
            <SocialComponents.ImageWrapper>
              <SocialComponents.SocialLinks
                data-label="botao-apple-store"
                onClick={handleTrackClick}
                to={data?.ios}
              >
                <Image src={appleStore} alt="Acessar aplicativo na App Store" />
              </SocialComponents.SocialLinks>
            </SocialComponents.ImageWrapper>
          </SocialComponents.ItemList>
        </SocialComponents.List>
      </SocialComponents.Section>

      <SocialComponents.Section>
        <FooterComponents.Title>Siga nossas redes sociais</FooterComponents.Title>
        <SocialComponents.List>
          <SocialComponents.ItemList>
            <SocialComponents.SocialLinks
              data-label="instagram"
              onClick={handleTrackClick}
              to={data?.instagram}
            >
              <Icon.SocialInstagram aria-label={data?.accessibility.instagramAlt} />
            </SocialComponents.SocialLinks>
          </SocialComponents.ItemList>

          <SocialComponents.ItemList>
            <SocialComponents.SocialLinks
              data-label="youtube"
              onClick={handleTrackClick}
              to={data?.youtube}
            >
              <Icon.SocialYoutube aria-label={data?.accessibility.youtubeAlt} />
            </SocialComponents.SocialLinks>
          </SocialComponents.ItemList>

          <SocialComponents.ItemList>
            <SocialComponents.SocialLinks
              data-label="facebook"
              onClick={handleTrackClick}
              to={data?.facebook}
            >
              <Icon.SocialFacebook aria-label={data?.accessibility.facebookAlt} />
            </SocialComponents.SocialLinks>
          </SocialComponents.ItemList>
        </SocialComponents.List>
      </SocialComponents.Section>
    </SocialComponents.Component>
  );
};
